import { ErrorWithMessage } from "./types";

export const isErrorWithMessage = (error: unknown): error is ErrorWithMessage =>
	typeof error === "object" &&
	error !== null &&
	"message" in error &&
	typeof (error as Record<string, unknown>).message === "string";
